import { EntidadeBase } from 'hay-core-react';
class PesquisaEnvioModel extends EntidadeBase {
    constructor() {
        super('pesquisaenvio');
    }
}
const instance = new PesquisaEnvioModel();
export default instance;
